<div class="loginBody">
    <div class="loginBody-content">
        <h1 class="loginTitle">
            {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
        </h1>
        <h2 class="loginHeader">
            {{ 'MODULES.LOGIN.SIGNUP_SUBHEADER' | transloco }}
        </h2>
        <div class="dsFieldWrap dsFieldError">
            <div class="dsLabel">{{ 'MODULES.LOGIN.EMAIL' | transloco }}<sup class="dsAsterix">*</sup></div>
            <mat-form-field appearance="outline" floatLabel="never">
                <input matInput type="text" required minlength="4" maxlength="100" />
            </mat-form-field>
        </div>
        <div class="dsFieldWrap">
            <div class="dsLabel">{{ 'MODULES.LOGIN.PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
            <mat-form-field appearance="outline" floatLabel="never">
                <input [type]="showPassword ? 'text' : 'password'" matInput required />
                <span (click)="showPassword = !showPassword" class="eye loginIcon" [ngClass]="{
                    'icon-pswdHide': !showPassword,
                    'icon-pswdShow': showPassword
                  }"></span>
            </mat-form-field>
        </div>
        <div class="dsFieldWrap">
            <div class="dsLabel">{{ 'MODULES.LOGIN.CONFIRM_PASSWORD' | transloco }}<sup class="dsAsterix">*</sup></div>
            <mat-form-field appearance="outline" floatLabel="never">
                <input [type]="showConfirmPassword ? 'text' : 'password'" matInput required />
                <span (click)="showConfirmPassword = !showConfirmPassword" class="eye loginIcon" [ngClass]="{
                    'icon-pswdHide': !showConfirmPassword,
                    'icon-pswdShow': showConfirmPassword
                  }"></span>
            </mat-form-field>
        </div>
    </div>
    <footer class="loginBody-footer">
        <button class="loginAction_btn">{{ 'MODULES.LOGIN.CREATE' | transloco }}</button>
        <div class="login-options">
            <div class="login-options-separator">
                {{ 'MODULES.LOGIN.OR' | transloco }}
            </div>
            <div class="login-options-link">
                <span>{{ 'MODULES.LOGIN.ALREADY_HAVE_LOGIN_AND_PASSWORD' | transloco }}</span>
                <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_IN' | transloco }}</span></a>
            </div>
        </div>
        <div class="login-copyright">© {{ currentYear }} Light & Wonder, Inc. and its Subsidiaries. All rights reserved
        </div>
    </footer>
</div>